module.exports = __webpack_public_path__ + "static/media/johnson.de82b968.png";